import React from 'react';
import PropTypes from 'prop-types';

import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import Typography from '@material-ui/core/Typography';

import styles from './successFailure.module.css';

const SuccessFailureView = ({ result, successMessage, failMessage, infoMessage }) => {
    if (infoMessage) {
        return (
			<div className={styles.container}>
				<InfoOutlinedIcon style={{ fontSize: 36, fill: '#007bff' }} /> <Typography className={styles['message-info']} variant="subtitle1">{infoMessage}</Typography>
			</div>
        )
    }

	if (result) {
		return (
			<div className={styles.container}>
				<CheckCircleOutlineIcon style={{ fontSize: 36, fill: 'green' }} /> <Typography className={styles['message-success']} variant="subtitle1">{successMessage}</Typography>
			</div>
		);
	}

	return (
		<div className={styles.container}>
			<ErrorOutlineIcon style={{ fontSize: 36, fill: 'red' }} /> <Typography className={styles['message-fail']} variant="subtitle1">{failMessage}</Typography>
		</div>
	);
};

SuccessFailureView.propTypes = {
	result: PropTypes.bool,
	successMessage: PropTypes.string,
	failMessage: PropTypes.string,
    infoMessage: PropTypes.string
};

export default SuccessFailureView;
